/* eslint-disable camelcase */

import { makeObservable, observable } from 'mobx'
import Model from './Model'

class Equipment extends Model {
  @observable id = 0
  @observable code = ''
  @observable name = ''

  constructor () {
    super()
    makeObservable(this)
  }
}

export default Equipment
